import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Navbar from './Components/navbar';
import Footer from './Components/footer';
import Home from './Pages/Home';

import Appointments from './Pages/Appointments';
import SpareParts from './Pages/SpareParts';
import Notifications from './Pages/Notifications';
import Login from './Pages/login';
import Register from './Pages/register';
import ServiceOwnerDashboard from './Pages/serviceownerdashboard';
import AdminDashboard from './Pages/Admindashbord';
import ProtectedRoute from './Components/auth/ProtectedRoute';
import RepairCentersList from './Components/repaircenterlist';
import RepairCenter from './Components/RepairCenters';
function App() {
  return (
    <Router>
      <div className="flex flex-col min-h-screen">
        <Navbar />
        <main className="flex-grow">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/repair-centers" element={<RepairCentersList />} />
            <Route path="/repair-center/:id" element={<RepairCenter />} />
            
            <Route path="/appointments" element={<Appointments />} />
            <Route path="/spare-parts" element={<SpareParts />} />
            <Route path="/notifications" element={<Notifications />} />
            <Route path="/register" element={<Register />} />
            <Route path="/login" element={<Login />} />

<Route 
  path="/service-owner/dashboard" 
  element={
    <ProtectedRoute requiredRole="serviceOwner">
      <ServiceOwnerDashboard />
    </ProtectedRoute>
  } 
/>
<Route 
  path="/admin/dashboard" 
  element={
    <ProtectedRoute requiredRole="admin">
      <AdminDashboard />
    </ProtectedRoute>
  } 
/>
</Routes>
</main>
<Footer />
</div>
</Router>
);
}

export default App;

